<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="800px" :destroy-on-close="true" :before-close="cancel">
    <el-form label-width="100px" ref="form" :model="form" class="section-header">
      <el-form-item label="负责公司" prop="responsibleCompany" :rules="{required: true, message: '请选择负责公司名称', trigger: 'change'}">
        <el-select style="width: 400px;" v-model="form.responsibleCompany" placeholder="请选择负责公司名称" filterable>
          <el-option v-for="item in companyOption"  :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-descriptions :column="2" :labelStyle="{'width':'125px', 'font-size': '15px', 'font-weight': 'bold'}"
                     border :contentStyle="{ 'font-size': '16px', 'width':'225px'}">
      <el-descriptions-item label="安排状态(干冰)" :span="2">
        <el-tag v-if="arrangeFlag === 1" type="success">已安排</el-tag>
        <el-tag v-else-if="arrangeFlag === 0" type="warning">待安排</el-tag>
        <el-tag v-else type="info">未知状态</el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="创建人">{{ createBy }}</el-descriptions-item>
      <el-descriptions-item label="创建时间">{{createTime}}</el-descriptions-item>
      <el-descriptions-item label="销售">{{salesName}}</el-descriptions-item>
      <el-descriptions-item label="收件人">{{recipientName}}</el-descriptions-item>
      <el-descriptions-item label="收件人电话">{{recipientPhone}}</el-descriptions-item>
      <el-descriptions-item label="收件人地址">{{recipientAddress}}</el-descriptions-item>
      <el-descriptions-item label="快递单号" v-if="trackingNumber!==''">{{trackingNumber}}</el-descriptions-item>
    </el-descriptions>
    <br>
    <el-descriptions title="申领物料信息"></el-descriptions>
    <el-descriptions :column="2" :labelStyle="{'width':'125px', 'font-size': '15px', 'font-weight': 'bold'}" border
                     :contentStyle="{ 'font-size': '16px', 'width':'225px'}"  v-for="(material,index) in materialRequestDetailDTOS" :key="index">
      <el-descriptions-item label="物料名称">
        {{material['materialLexiconDTO'].materialName}}
      </el-descriptions-item>
      <el-descriptions-item label="数量">
        {{material.number}}
      </el-descriptions-item>
    </el-descriptions>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" class="title" @click="cancel">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="handle">确定安排</el-button>
    </div>
  </el-dialog>
</template>

<script>

import ExFoldCellToo from "@/components/ExFoldCellToo.vue";
import {arrangeDryIce} from "@/api/dilivery/material/request";
import {needRedDoltInfo} from "@/utils/data/basicData/leftNavData";
import {getDataInLocalStorage} from "@/utils/localStorage";

export default {
  name: "ArrangeDryIce",
  components: {ExFoldCellToo},
  props:['showDialog','selectDetail','auditDetail'],
  data(){
    return{
      companyOption:['上海域丰','西安传奇'],
      data:{name:'materialLexiconDTO.materialName',value:'number'},
      title:'干冰安排',
      id:'',
      status: '',
      rejectionReason: '',
      operator: '',
      auditTime: '',
      salesName:'',
      recipientName: '',
      createBy:'',
      createTime:'',
      trackingNumber:'',
      materialRequestDetailDTOS:[],
      recipientAddress:'',
      recipientPhone:'',
      trackingFlag: '',
      arrangeFlag: '',
      form:{
        id:'',
        responsibleCompany:''
      }
    }
  },
  watch:{
    selectDetail:{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
          if(newVal.trackingNumber){
            this.trackingNumber = newVal.trackingNumber
          }
          if(newVal.materialRequestDetailDTOS){
            this.materialRequestDetailDTOS = newVal.materialRequestDetailDTOS
          }
          if(newVal.sales){
            this.salesName = newVal.sales.name
          }
          this.recipientName = newVal.recipientName
          this.recipientAddress = newVal.recipientAddress
          this.recipientPhone = newVal.recipientPhone
          this.createBy = newVal.createBy
          this.createTime = newVal.createTime
          this.arrangeFlag = newVal.arrangeFlag
        }
      },
      immediate:true
    },
  },
  methods:{
    cancel(){
      this.$emit('submit','cancel')
    },
    handle() {
      this.$refs.form.validate(valid=>{
        if(valid){
          arrangeDryIce(this.form).then(res => {
            if(res.code === 200){
              this.$messageUi.success('安排干冰信息成功')
              this.$emit('submit','confirm')
              this.$store.commit('right/setChangeRed',true)
            }
          }).catch(err => {
          })
        }else{
          this.$messageUi.error('填写参数不规范，请检查')
        }})
    }
  },
}
</script>

<style scoped >
.section-header {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
  padding: 10px;
  font-weight: bold;
  border-bottom: 1px  #ebeef5;
}
</style>
